import React from 'react';

// atoms
import Alert from '../../atoms/icons/alert';
import Text from '../../atoms/text';
import Button from '../../atoms/button';

// molecules
import PhoneList from '../../molecules/phoneList';

// style
import './style.scss';

export default () => {
  const phonesList = [
    {
      number: '51 3218 8200',
      text: 'Porto Alegre e região metropolitana:'
    },
    {
      number: '0800 642 8200',
      text: 'Interior do Rio Grande do Sul:'
    }
  ];
  return (
    <>
      <Alert />
      <Text>
        Nosso período de degustação é voltado para quem ainda não conhece nosso
        produto.
      </Text>
      <Button to="https://gauchazh.clicrbs.com.br/" external>
        Acessar GaúchaZH
      </Button>
      <PhoneList phones={phonesList} />
    </>
  );
};
